import {CommonActions} from './commonActions';

export function acceptTermCond(){
  var data= {
    AC:JSON.parse(localStorage.getItem('DefaultAC')).AC,
    UC:localStorage.getItem('trdCode'),
    AD:JSON.parse(localStorage.getItem('DefaultAC')).AD
  }
  return (dispatch) => {
    dispatch(CommonActions.handleAPICall(data,'/acceptTerm','ACCEPT', 'POST',));
  };

  // return{
  //     types:[ACCEPT,ACCEPT_SUCCESS,ACCEPT_FAIL],
  //     promise:(client) => client.post('/acceptTerm',{
  //       data:{
  //       AC:JSON.parse(localStorage.getItem('DefaultAC')).AC,
  //       UC:localStorage.getItem('trdCode'),
  //       AD:JSON.parse(localStorage.getItem('DefaultAC')).AD,
  //       }
  //   })
  // };
}
// export function declineTermCond(){
//  localStorage.setItem('TC',"false");
//   return{
//       types:[DECLINE,DECLINE_SUCCESS,DECLINE_FAIL],
//       promise:(client) => client.post('/declineTerm',{})
//   };
// }
//not in used need to cross check before delete
export function login(user) {
  var data= {
    username: user.name,
    password: user.password,
    location: user.location,
    forcedLogin:user.forcedLogin
  }
  return (dispatch) => {
    dispatch(CommonActions.handleAPICall(data,'/restlogin','LOGIN', 'POST',{user}));
  };

  // return {
  //   types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
  //   user,
  //   promise: (client) => client.post('/restlogin', {
  //     data: {
  //       username: user.name,
  //       password: user.password,
  //       location: user.location,
  //       forcedLogin:user.forcedLogin
  //     }
  //   })
  // };
}
export function logout(logoutOnClose) {
  return (dispatch) => {
    const data = {isPasswordReset : false};
    dispatch(CommonActions.handleAPICall(data,'/restlogout','LOGOUT', 'POST'));
  };
}
export function closeForceLogout(){
  return {
    type: 'FORCED_LOGOUT_CLOSED'
  };
}
export function setLoginErrorMsg(){
  return {
    type:'LOGIN_MESSAGE'
  };
}
export function resetpass_flag(){
   localStorage.setItem('TC',"false");
  return{
    type:'RESETPASS_FLAG',
  };
}
export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}
/**
 * Actytion to fetch current user data.
 */
export function load() {
  return {
    type: 'LOAD_SUCCESS',
    result: {
      status: 'failure',
      authToken: null
    }
  };
}
export function changeLoaderLogin(){
  return{
    type: 'RSET_LOGIN_LOADER_FLAG',
  };
}
export function changeState(flag){
  return {
    type:'CHANGE',
    status:flag
  };
}

/** Use this function to connect with logout api*/
 export function killSeesionlogout() {
 	  return {
 	    type:'KILL_LOGOUT'
 	  };
 	}


export function showLoadingIndicator() {
  return {
    type: 'LOADING_ON'
  };
}

export function stopLoadingIndicator() {
  return {
    type: 'LOADING_OFF'
  };
}
export function handleSession() {
  return {
    type: 'HANDLE_SESSION'
  };
}
